<template>
  <div id="milkStar" class="milkStar">
    <div class="star-header">
      <img alt="" src="@/assets/images/powderedMilk/naifenxingqiu.png" />
      <span class="head-title">一站式解决喂养难题</span>
    </div>
    <div class="star-main">
      <star-left
        :starList="starList"
        style="flex-shrink: 0"
        @handlerTab="handlerTab"
      ></star-left>
      <div class="star-div">
        <star-right
          ref="starRight"
          :activeISKey="activeISKey"
          :articleInfoLists="articleLists"
          :isShowInit="isInit"
          :loadShow="loadShow"
          :parentName="parentName"
          :stairLabelInfo="stairLabel"
          :switchList="switchList"
          style="flex-shrink: 0"
        ></star-right>
      </div>
    </div>
  </div>
</template>
<script>
// import minxins from '@/minxs/milkPowderStar.js'
import starLeft from "./starLeft.vue";
import starRight from "./starRight.vue";
import API from "@/utils/axiosApi/powderedMilkApi.js";
import { BuiedPointClick_Fn } from "@/assets/js/BuriedPointEvent";
import { getCookie } from "@/assets/js/common.js";

export default {
  name: "milkStar",
  // mixins: [minxins],
  data() {
    return {
      starList: [], // 左边一级标签
      switchList: [], // 右边二级标签
      parentName: "", // 一级标签名称
      optionList: [],
      articleLists: [],
      loadShow: false,
      isInit: false,
      stairLabel: 0,
      activeISKey: 0,
    };
  },

  activated() {
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "你要的奶粉知识都在这里了",
      shareTitle: "超全奶粉知识,三甲医院专家专业解读",
      imgUrl: "https://image-mom.feihe.com/wxshare/powderedMilk.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    getMilkInfoList(data) {
      this.loadShow = true;
      let UserInfo = JSON.parse(localStorage.getItem("userInfo"));
      let babybirth = "",
        currentBaby = "";
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      if (babyInfo) {
        currentBaby = getCookie("babyNum");
        const currentBabyInfo = babyInfo.filter((item) => {
          return item.num == currentBaby;
        });
        console.log(currentBabyInfo, "currentBabyInfocurrentBabyInfo");
        babybirth =
          currentBabyInfo && currentBabyInfo.length
            ? currentBabyInfo[0].birth
            : "";
      }
      const obj = {
        page: 1,
        size: 20,
        data: {
          parentId: data.stairLabel,
          planetTag: data.secondLabel,
          crmId: UserInfo == null ? "" : UserInfo.crm_id,
          isRecommend: data.isRecommend == 0 ? 0 : 1,
          babyBirthDay: babybirth,
        },
      };
      console.log(obj, "objApi");
      API.getListByTag(obj, (res) => {
        if (res.code == 200) {
          this.articleLists = res.data.content;
          this.loadShow = false;
          if (this.articleLists && this.articleLists.length) {
            this.isInit = true;
          } else {
            this.isInit = false;
          }
        }
      });
    },
    // 点击一级左边菜单
    handlerTab(item) {
      this.parentName = item.parentName;
      this.switchList = item.tagList || [];
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      console.log(babyBuried,item.parentName,'babyBuried');
      console.log(item.parentName,'babyBuried11');
      BuiedPointClick_Fn("milkinfo_home_star_firstclassify_click", {
        Baby_Month:  babyBuried ? babyBuried.name : "",
        firstclassify_name: item.parentName,
      });
      if (this.stairLabel == item.labelId) {
        this.activeISKey = 0;
      } else {
        this.stairLabel = item.labelId;
        if (item.labelId) {
          this.articleLists = [];
          this.getMilkInfoList({
            stairLabel: item.labelId,
            secondLabel: item.tagList[0].childId,
          });
        } else {
          this.getMilkInfoList({
            stairLabel: 0,
            secondLabel: 0,
            isRecommend: 0,
          });
        }
      }
    },
    getInfoTagList() {
      let obj = {
        tagId: 0, //父级id 0：全部
        module: 0, //模块id 0:奶粉百科
        tagType: 1, // 标签类型 0：专题 1：星球
      };
      API.getTagAll(obj, (res) => {
        if (res.code == 200) {
          const data = res.data;
          data.forEach((item) => {
            const obj = { childId: 0, childName: "全部" };
            item.tagList.unshift(obj);
          });
          this.starList = [
            { parentName: "推荐", labelId: 0, tagList: [] },
            ...data,
          ];
          this.switchList = this.starList[0].tagList;
          this.stairLabel = 0;
          this.parentName = "推荐";
          this.getMilkInfoList({
            isRecommend: 0,
            stairLabel: 0,
            secondLabel: 0,
          });
        }
      });
    },
  },
  created() {
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "你要的奶粉知识都在这里了",
      shareTitle: "超全奶粉知识,三甲医院专家专业解读",
      imgUrl: "https://image-mom.feihe.com/wxshare/powderedMilk.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    this.getInfoTagList();
  },
  components: {
    starLeft,
    starRight,
  },
};
</script>
<style lang="less" scoped>
#milkStar::-webkit-scrollbar {
  display: none;
}

#milkStar {
  width: 100%;
  height: auto;
  //max-height: 586px;
  //min-height: 554px;
  //height: 586px;

  background: #fff;
  border-radius: 6px;
  overflow: hidden;

  .star-header {
    width: 100%;
    height: 49px;
    display: flex;
    flex-direction: row;

    img {
      width: 80px;
      height: 22px;
      margin-top: 16px;
      margin-left: 4px;
    }

    .head-title {
      margin-top: 19px;
      font-size: 12px;

      &::before {
        content: "";
        width: 1px;
        height: 1px;
        margin-left: 2px;
        border: 2.5px solid #ccc;
        border-radius: 50%;
        display: inline-block;
        background: #ccc;
        margin-right: 6px;
        margin-bottom: 1px;
      }
    }
  }

  .star-main {
    display: flex;
    flex-basis: auto;
    //padding-bottom: 32px;
    height: 100%;
  }

  .star-div {
    flex: 1;
  }
}
</style>
